import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";


import { ThemeProvider } from '@mui/material/styles';
import CentricTheme from "../../themes/CentricTheme";



import Calendar from "../Applications/CENT/Calendar/Calendar"
import Dashboard from "../Dashboard/Dashboard";
import Help from "../Help/Help";
import AbsenceList from "../Applications/CENT/Leave/AbsenceList";
import Message from "../Applications/CENT/Message/Message";
import MessageList from "../Applications/CENT/Message/MessageList";
import NotificationList from "../Applications/CENT/Notifications/NotificationList";
import Profile from "../Profile/Profile";
import Settings from "../Settings/Settings";
import SubscriptionList from "../Applications/CENT/Subscriptions/SubscriptionList";
import Tasks from "../Applications/CENT/Task/TaskList";
import Terms from "../Applications/CENT/Term/TermList";

import JPRouter from "../Applications/JP";
import RMSRouter from "../Applications/RMS";
import TMSRouter from "../Applications/TMS";
import LRSRouter from "../Applications/LRS";
import MSFRouter from "../Applications/MSF";
import RSRouter from "../Applications/RS";
import X360Router from "../Applications/X360";
import PortfolioRouter from "../Applications/PORT";
import Error404 from "../Errors/Error404";

const MainRouter = () => (
    <ThemeProvider theme={CentricTheme}>
        <Switch>
            {/* redirect / to dashboard: */}
            <Route exact path="/"><Redirect to={"/dashboard"} /></Route>
            {/* main routing */}
            <Route exact path="/calendar" component={Calendar} />
            <Route exact path="/dashboard" component={Dashboard} />
            <Route exact path="/help" component={Help} />
            <Route exact path="/absences" component={AbsenceList} />
            <Route exact path="/messages/:id" component={Message} />
            <Route exact path="/messages" component={MessageList} />
            <Route exact path="/notifications" component={NotificationList} />
            <Route exact path="/profile" component={Profile} />
            <Route exact path="/settings" component={Settings} />
            <Route exact path="/subscriptions" component={SubscriptionList} />
            <Route exact path="/tasks" component={Tasks} />
            <Route exact path="/terms" component={Terms} />

            <Route path="/jp" component={JPRouter} />
            <Route path="/lrs" component={LRSRouter} />
            <Route path="/rms" component={RMSRouter} />
            <Route path="/tms" component={TMSRouter} />
            <Route path="/msf" component={MSFRouter} />
            <Route path="/rs" component={RSRouter} />
            <Route path="/x360" component={X360Router} />
            <Route path="/portfolio" component={PortfolioRouter} />

            {/* 404:*/}
            <Route path="*" component={Error404} />
        </Switch>
    </ThemeProvider>
);

export default MainRouter;
